// extracted by mini-css-extract-plugin
export default {"directQuote":"TextSlider_directQuote__mGyzs","authorsRow":"TextSlider_authorsRow__g-u-B","authorsCol":"TextSlider_authorsCol__ADFJA","authorsText":"TextSlider_authorsText__6Y+FP"};